import CurrencyForm from "components/Currencies/form"
import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { storeCurrency } from "store/currency/currency-action"

const AddCurrency = () => {
  document.title = "Add Currency"

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, error, data } = useSelector(state => state.currency)

  /*
  - handleSubmit: Triggered when the form is submitted
  - values: Contains the form input values
  - Dispatches the action to store the Currency with the provided values
  */
  const handleSubmit = values => {
    dispatch(storeCurrency(values, navigate))
  }

  return (
    <CurrencyForm
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      formMode={"Add"}
    />
  )
}

export default AddCurrency
